// extracted by mini-css-extract-plugin
module.exports = {"label":"FilterUnassign_label__38khT"};